import useSession from 'hooks/useSession'
import { useOrderState } from './useOrderState'
import { useSavedOrder } from './useCartState'

export const useIsExtraDeal = () => {
  const pendingOrder = useSession((s) => s.pendingOrder)
  const items = useOrderState((s) => s.order.items)
  const savedOrder = useSavedOrder(pendingOrder?.savedOrderId)

  if (!pendingOrder) {
    return false
  }

  return items?.[0]?.id !== savedOrder?.order.items[0].id
}

export const useIsExtraDealPending = () => {
  const pendingOrder = useSession((s) => s.pendingOrder)
  const items = useOrderState((s) => s.order.items)
  const savedOrder = useSavedOrder(pendingOrder?.savedOrderId)

  return {
    order: pendingOrder,
    isPending: items?.[0]?.id === savedOrder?.order.items[0].id,
  }
}
